import { api } from "../api";
import { GroupDefault } from "../../contexts/auth";
import moment from "moment";

function typeOf(obj) {
  return {}.toString.call(obj).split(" ")[1].slice(0, -1).toLowerCase();
}

export async function getNewCustomer() {
  try {
    const { data } = await api.get(
      `/customerservice?usuario_id=${GroupDefault()}&aberto=S`
    );
    return data;
  } catch (error) {
    return false;
  }
}

export async function getMyCustomer(id) {
  try {
    const { data } = await api.get(
      `/customerservice?usuario_id=${id}&aberto=S`
    );
    return data;
  } catch (error) {
    return false;
  }
}

export async function getCloseCustomer(
  id,
  client_id,
  usuario_id,
  dt_ini,
  dt_fim
) {
  if (!id) id = 0;
  let params = {
    id: parseInt(id),
    client_id: parseInt(client_id),
    usuario_id: parseInt(usuario_id),
    aberto: "N",
    dt_ini,
    dt_fim,
  };
  try {
    const { data } = await api.get("/customerservice", { params });
    if (typeOf(data) === "object") return [data];
    return data;
  } catch (error) {
    return false;
  }
}

export async function getFullCustomer() {
  try {
    const { data } = await api.get(`/customerservice?aberto=S`);
    return data;
  } catch (error) {
    return false;
  }
}

export async function postCustomer(
  idClient,
  idUser,
  verificationIsCustomerOpen
) {
  try {
    if (verificationIsCustomerOpen) {
      const customerServiceOpen = await qtdCustomerServiceOpen(idClient);
      if (customerServiceOpen?.length > 0)
        return { status: "clone", customerServiceOpen: customerServiceOpen };
    }
    const {
      data: { customerservice },
    } = await api.post(
      `/customerservice?client_id=${idClient}&usuario_id=${idUser}&started_at=${moment(
        new Date()
      ).format("YYYY-MM-DD HH:mm:ss")}&mudar_gateway=${"S"}`
    );
    if (customerservice) return customerservice;
    return false;
  } catch (error) {
    return false;
  }
}

export async function transferCustomer(
  customer,
  note,
  new_user,
  motivationId,
  verificationCustomerOpen
) {
  try {
    if (verificationCustomerOpen) {
      const customerServiceOpen = await qtdCustomerServiceOpen(
        customer.client_id
      );
      if (customerServiceOpen?.length > 0)
        return { status: "clone", customerServiceOpen: customerServiceOpen };
    }
    var parameters = {
      id: customer.id,
      client_id: customer.client_id,
      usuario_id: new_user,
      transferido_em: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      note: note,
      motivo_encaminhamento_id: motivationId,
      empresa_id: customer.empresa_id,
      url_base: "",
    };
    const { status, data } = await api.put(
      `/customerservice/transferir`,
      parameters
    );
    if (status !== 200) return false;
    return data;
  } catch (error) {
    return false;
  }
}

export async function closeCustomer(customer, note) {
  try {
    const { status } = await api.put(
      `customerservice?id=${customer.id}&client_id=${
        customer.client_id
      }&finished_at=${moment(new Date()).format(
        "YYYY-MM-DD HH:mm:ss"
      )}&empresa_id=${customer.empresa_id}&note=${note ? note : null}`
    );
    if (status === 200) return true;
    return false;
  } catch (error) {
    return false;
  }
}

export async function qtdCustomerServiceOpen(client_id, includeGroups) {
  try {
    const { data } = await api.get(
      `/customerservice?client_id=${client_id}&aberto=S&mostrar_grupo=${
        includeGroups ? "S" : "N"
      }`
    );
    return data;
  } catch (error) {
    return false;
  }
}

export async function getCustomerServiceExistsType(client_id, type) {
  try {
    const { data } = await api.get(
      `/customerservicexiststype?client_id=${client_id}&type=${type}`
    );
    return data;
  } catch (error) {
    return false;
  }
}

export async function getMotivation() {
  try {
    const { data } = await api.get(`motivoencaminhamento`);
    return data;
  } catch (error) {
    return false;
  }
}

export async function postCustomerTypeLink(idUser, customerRoot) {
  try {
    const {
      status,
      data: { customerservice },
    } = await api.post(
      `/customerservice?client_id=${
        customerRoot.client_id
      }&usuario_id=${idUser}&started_at=${moment(new Date()).format(
        "YYYY-MM-DD HH:mm:ss"
      )}&customer_service_id_root=${customerRoot.id}`
    );
    if (status === 200) return customerservice;
    return false;
  } catch (error) {
    return false;
  }
}

export async function putCustomerTypeLink(customer, type, link) {
  try {
    const { status } = await api.put(
      `customerservice?id=${customer.id}&client_id=${customer.client_id}&type=${type}&link=${link}&empresa_id=${customer.empresa_id}`
    );
    if (status === 200) return true;
    return false;
  } catch (error) {
    return false;
  }
}

export async function initializeCustomerServiceLote(IDs) {
  const parameters = {
    id: IDs.join(","),
    transferido_em: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  };
  try {
    const { status, data } = await api.put(
      `/customerservice/transferir-lote`,
      parameters
    );
    return {
      status,
      message: data.msg,
    };
  } catch (error) {
    return false;
  }
}

export async function transferCustomerServiceLote(
  usuario_id,
  IDs,
  note,
  motivationId
) {
  const parameters = {
    usuario_id: usuario_id,
    id: IDs.join(","),
    transferido_em: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    note: note,
    motivo_encaminhamento_id: motivationId,
  };
  try {
    const { status, data } = await api.put(
      `/customerservice/transferir-lote`,
      parameters
    );
    return {
      status,
      message: data.msg,
    };
  } catch (error) {
    return false;
  }
}

export async function finishCustomerServiceLote(IDs) {
  const parameters = {
    id: IDs.join(","),
    transferido_em: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  };
  try {
    const { status, data } = await api.put(
      `/customerservice/finaliza-lote`,
      parameters
    );
    return {
      status,
      message: data.msg,
    };
  } catch (error) {
    return false;
  }
}

export async function updateCustomerServiceCall(dataCall, type) {
  const { customer, call } = dataCall;
  const link = JSON.stringify(call);
  try {
    const resp = await api.put(
      `customerservice?id=${customer.id}&client_id=${customer.client_id}&type=${type}&link=${link}&empresa_id=${customer.empresa_id}`
    );
    if (resp?.status === 200) return true;
    return false;
  } catch (error) {
    console.log("❌ ", error);
    return false;
  }
}

export async function createCustomerServiceCall(idUser, customerRoot) {
  try {
    const {
      status,
      data: { customerservice },
    } = await api.post(
      `/customerservice?client_id=${
        customerRoot.client_id
      }&usuario_id=${idUser}&started_at=${moment(new Date()).format(
        "YYYY-MM-DD HH:mm:ss"
      )}&customer_service_id_root=${customerRoot.id}`
    );
    if (status === 200) return customerservice;
    return false;
  } catch (error) {
    return false;
  }
}